import { motion } from 'framer-motion';
import { SectionHeading } from './Features';

const STEPS = [
  {
    n: '01',
    title: 'Add the extension',
    body: 'Install Vela from the Chrome Web Store. It sits quietly in your toolbar until you need it.',
  },
  {
    n: '02',
    title: 'Create or restore',
    body: 'Set a password to encrypt your device vault, then generate a fresh mnemonic or restore an existing one.',
  },
  {
    n: '03',
    title: 'Connect and transact',
    body: 'Approve dApps one at a time, sign what you intend to sign, and manage every account from one place.',
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="relative border-t border-white/[0.05] bg-midnight-950 py-28">
      <div className="mx-auto max-w-6xl px-6">
        <SectionHeading
          eyebrow="Getting started"
          title="Three steps, then you're in control."
          align="center"
        />

        <div className="relative mt-16 grid grid-cols-1 gap-10 sm:grid-cols-3">
          <div className="pointer-events-none absolute left-0 right-0 top-[26px] hidden border-t border-dashed border-white/10 sm:block" />
          {STEPS.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="relative text-center sm:text-left"
            >
              <span className="relative z-10 inline-flex h-[52px] w-[52px] items-center justify-center rounded-full border border-white/10 bg-midnight-900 font-display text-lg text-teal-soft">
                {step.n}
              </span>
              <h3 className="mt-5 text-xl">{step.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-mist">{step.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
